import React, { useCallback, useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  SearchOutlined,
} from "@mui/icons-material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { dateTimeToView } from "../../../utils/date.utils";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { debouncedApiCall } from "../../../utils/app.utils";
import FilterSelect from "../../../components/select/filterSelect";
import { MenuItem, useMediaQuery, useTheme } from "@mui/material";
import { icons } from "../../../assets/icons/icons";
import { classRoomApi } from "../../../api/class-room/class-room.api";
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { useTranslation } from "react-i18next";

type Props = {};

const ManageClassRoom: React.FC<Props> = ({ }: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const [data, setData] = useState<any[]>([]);

  const [dataAcademicYear, setDataAcademicYear] = useState<any[]>([]);
  const [dataDegree, setDataDegree] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState<any[]>([]);
  const [dataClassRoom, setDataClassRoom] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [inputValueSearch, setInputValueSearch] = useState({
    academic_year: "",
    degree: "",
    faculty: "",
    year: "",
    class: "",
  });
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getClassRoom = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      year_education: inputValueSearch.academic_year,
      id_degree: inputValueSearch.degree,
      id_faculty: inputValueSearch.faculty,
      // year: inputValueSearch.year,
      room: inputValueSearch.class,
    };

    if (search) query.search = search;
    await classRoomApi.getAllClassRoom(query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setData(data.data.items);
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
      } else {
        setData([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [page, pageLimit, sortBy, sortType, search, inputValueSearch])

  const handleDelete = async (id: number) => {
    if (id) {
      alertActive(
        t("ลบชั้นเรียน"),
        t("ท่านต้องการลบชั้นเรียน ใช่หรือไม่"),
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await classRoomApi
            .deleteClassRoom(+id)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  t("ลบชั้นเรียน เรียบร้อย"),
                  undefined,
                  undefined,
                  () => {
                    getClassRoom();
                  }
                );
              }
            })
            .catch(() => {
              alertError(t("ชั้นเรียน ไม่สำเร็จ"));
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "academic_year",
      width: 10,
      disablePadding: true,
      align: "start",
      label: t("ปีการศึกษา"),
    },
    {
      id: "degree",
      disablePadding: true,
      width: 25,
      align: "center",
      label: t("ระดับ"),
    },
    {
      id: "faculty",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("หลักสูตร"),
    },
    {
      id: "class_room",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("ห้อง"),
    },
    {
      id: "student_amount",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("จำนวนนักศึกษา"),
    },
    {
      id: "updated_by",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("ผู้สร้าง/ปรับปรุงล่าสุด"),
    },
    {
      id: "last_updated",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("วันที่ปรับปรุงล่าสุด"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 25,
      label: "action",
      class: matches && data?.length > 0,
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      year_start,
      id_class_room,
      degree_name,
      faculty_name,
      room,
      first_name_modified,
      last_name_modified,
      countStudent,
      modified_date,
    } = objData;

    const objRenderData = {
      key: id_class_room,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: year_start,
        },
        {
          option: "TEXT",
          align: "center",
          label: degree_name,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: faculty_name,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: room,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: countStudent,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: first_name_modified + " " + last_name_modified,
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? dateTimeToView(modified_date) : "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.ManageClassRoom +
                    `/${id_class_room}/update?view-only=true`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.ManageClassRoom +
                    `/${id_class_room}/update?view-only=false`
                  );
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleDelete(id_class_room);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear + 5;
    const buddhistYearOffset = 543;

    const academicYears = [];
    for (let year = startYear; year <= endYear; year++) {
      academicYears.push(year + buddhistYearOffset);
    }

    setDataAcademicYear(academicYears);
  }, []);

  useEffect(() => {
    getClassRoom();
  }, [getClassRoom]);

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getDataDegree = async () => {
    await degreeApi.getDegree().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataDegree(data.data);
      } else {
        setDataDegree([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const getDataFaculty = useCallback(async () => {
    await facultyApi.listFaculty(inputValueSearch.degree ? +inputValueSearch.degree : undefined).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataFaculty(data.data);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [inputValueSearch.degree])

  const getDataClassRoom = async () => {
    const res = await classRoomApi.getClassRoomOption();
    const data = res.data;
    if (data.status < 300) {
      setDataClassRoom(data.data);
    } else {
      setDataClassRoom([]);
    }
  };

  useEffect(() => {
    getDataFaculty();
  }, [getDataFaculty])
  useEffect(() => {
    getDataDegree();
    getDataClassRoom();
  }, []);

  return (
    <div>
      <ContentHeading
        title={t("จัดการชั้นเรียน")}
        detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-2  md:col-span-3  sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหา ชื่อ - นามสกุล/เลขประจำตัว")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.academic_year ?? ""}
            labelId="academic_year-id"
            selectId="academic_year-select-id"
            options={[
              {
                id_academic_year: "",
                academic_year_name: t("ทุกปีการศึกษา"),
              },
              ...dataAcademicYear.map((year) => ({
                id_academic_year: year.toString(), // Ensure year is a string
                academic_year_name: year.toString(), // Ensure year is a string,
              })),
            ].map((year, index) => (
              <MenuItem value={year.id_academic_year} key={index}>
                {year.academic_year_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValueSearch("academic_year", e.target.value);
            }
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.degree ?? ""}
            labelId="degree-id"
            selectId="degree-select-id"
            options={[
              {
                id_degree: "",
                degree_name: t("ทุกระดับ"),
              },
              ...dataDegree.map((item) => ({
                id_degree: item.id_degree,
                degree_name: item.degree_name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_degree} key={index + 1}>
                {list.degree_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValueSearch("degree", e.target.value);
              handleChangeValueSearch("faculty", "");
            }}
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.faculty ?? ""}
            labelId="faculty-id"
            selectId="faculty-select-id"
            options={[
              {
                id_faculty: "",
                faculty_name: t("ทุกหลักสูตร"),
              },
              ...dataFaculty.map((item, index) => ({
                id_faculty: item.id_faculty, // Ensure year is a string
                faculty_name:
                  item.faculty_name.length > 30
                    ? item.faculty_name.slice(0, 30) + "..."
                    : item.faculty_name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_faculty} key={index + 1}>
                {list.faculty_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("faculty", e.target.value)
            }
          />
        </article>

        {/* <article className="w-full col-span-12 lg:col-span-1 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.year ?? ""}
            labelId="year-id"
            selectId="year-select-id"
            options={[
              {
                id_year: "",
                year_name: "ทุกชั้นปี",
              },
            ].map((list, index) => (
              <MenuItem value={list.id_year} key={index + 1}>
                {list.year_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("year", e.target.value)
            }
          />
        </article> */}

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.class ?? ""}
            labelId="class-id"
            selectId="class-select-id"
            options={[
              {
                id_class: "",
                class_name: t("ทุกห้อง"),
              },
              ...dataClassRoom.map((item, index) => ({
                id_class: item.room,
                class_name: item.room,
              })),
              // dataClassRoom
            ].map((list, index) => (
              <MenuItem value={list.id_class} key={index + 1}>
                {list.class_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("class", e.target.value)
            }
          />
        </article>

        <article
          className="w-full col-span-12 lg:col-span-2 md:col-span-4 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <ButtonPrimary
            onClick={() => {
              navigate(routeName.cms.CreateClassRoom);
            }}
            mode="add"
            buttonName={t("เพิ่มชั้นเรียน")}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ManageClassRoom;
